
import { useEffect, useState, useRef } from 'react';
import { MapContainer, MapContainerProps, Marker, Popup, SVGOverlay, TileLayer } from 'react-leaflet';
import "leaflet/dist/leaflet.css";
import icon from "leaflet/dist/images/marker-icon.png";
import L from "leaflet";
import { LatLngBoundsExpression } from 'leaflet';
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { useNavigate, useLocation } from 'react-router-dom';
import './DetalleEntidadEncuestada.css';
import LogoBis from "../../../common/components/LogoBis/LogoBis";
import MenuHeader from "../../../common/components/MenuHeader/MenuHeader";
import OutLineButton from '../../../common/components/OutLineButton/OutLineButton';
import { COLORS } from '../../../common/constants/colors';
import { ActiveFormListDetailByFormID, ActiveOrBlockFormListDetail, getFormsDetailsByFormListDetailID } from '../../../services/survey';
import { useForm } from '../../../contexts/form';
import { IFormListDetail } from '../../../interfaces/IFormListDetail';
import { DetalleTipo, VisualizacionFormulario } from '../../../common/enums/AllEnums';
import { DeactivateQuestionsGroupByID } from '../../../services/questionGroup';
import Atributos from '../../Atributos/Atributos';
import { getError, openNotification, tryCatch } from '../../../common/constants/Utilities';
import Modal from '../../../common/components/Modal/Modal';
import { LoadingIcon } from '../../../common/constants/cssElements';
import LoadingButton from '../../../common/components/LoadingButton/LoadingButton';
import LabelNotFound from '../../../common/components/Label/LabelNotFound';
import LoadingPage from '../../../common/components/LoadingPage/LoadingPage';
import NoticeLeavePageItem from '../../../common/components/PreventLeavePageItem/NoticeLeavePageItem';
import { IEntitySurvey } from '../../../interfaces/IEntitySurvey';


const DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const DetalleEntidadEncuestada = () => {
    const { entitySurveySelected, questionForm } = useForm();
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const [listFormsListDetails, setFormsListDetails] = useState<IFormListDetail[]>([]);
    const [location, setLocation] = useState<{ longitud: number | null, latitud: number | null }>({ latitud: null, longitud: null })
    const [isLocation, setIsLocation] = useState<Boolean>(false)
    const [telefono, setTelefono] = useState<string[]>([]);
    const [linkMapa, setLinkMapa] = useState([]);
    const [detalle, setDetalle] = useState<{ nombre: string, valor: string }[]>([]);
    const [objMapa, setObjMapa] = useState<{ bounds: LatLngBoundsExpression, text: string }>({
        bounds: [
            [19.176301302579176, -71.1199951171875],
            [18.7971180132841, -70.191650390625],
        ],
        text: "No hay ubicacion disponible para mostrar"
    });
    const navigate = useNavigate();
    const mapRef = useRef<any>('');
    const googleMapsUrl = `https://maps.google.com?q=${location.latitud},${location.longitud}`;


    const getFormsListDetails = () => {
        tryCatch(() => {
            setFormLoading(true);
            getFormsDetailsByFormListDetailID(entitySurveySelected?.formularioListadoDetalleID!)
                .then((response) => {
                    //Obtenemos el resultado
                    setFormsListDetails(response.data);
                    //
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setFormLoading(false));
        })
        //Obtenemos el resultado

    }

    const goToSecuentialSurvey = () => {
        localStorage.setItem('IsLeave', JSON.stringify(false)); // Desbloqueo navegacion hacia pagina siguiente
        if (!questionForm?.bloquearPaginacion) {
            bloquearEntidad(entitySurveySelected!)
        } else {
            if (questionForm?.esFormularioSecuencial === true) {
                navigate(`/SequentialSurvey`);
            } else {
                navigate(`/EncuestaNoSequencial`);
            }
        }

    }

    const bloquearEntidad = (entityToSurvey: IEntitySurvey) => {
        tryCatch(() => {
            ActiveOrBlockFormListDetail(entityToSurvey?.formularioListadoDetalleID!, true)
                .then((response) => {
                    if (questionForm?.esFormularioSecuencial === true) {
                        navigate(`/SequentialSurvey`);
                    } else {
                        navigate(`/EncuestaNoSequencial`);
                    }
                })
                .catch((response) => {

                    openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                })
                .finally(() => { });
        })
    }
    // Verificar cuando el usuario abandone esta pagina.
    const desbloquearEntidad = () => {
        tryCatch(() => {
            setFormLoading(true);
            if (questionForm?.bloquearPaginacion) {
                ActiveFormListDetailByFormID(questionForm.formularioID)
                    .then((response) => {
                        //Desbloqueado Formulario listado Detalle (Lista Clientes)
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                    })
                    .finally(() => setFormLoading(false));
            }
        })
    }

    const handleAsingValueDetail = () => {
        const _telefonos: string[] = [];
        const _textDetails: { nombre: string, valor: string }[] = [];

        setLocation({ longitud: null, latitud: null });
        mapRef.current?.setView({ lat: 19.047839415523136, lng: -70.66680908203125 }, 10);
        setIsLocation(false);

        listFormsListDetails.forEach(detail => {
            if (detail.detalleTipoNombre === DetalleTipo.BotonLLamar) {
                _telefonos.push(detail.valor)
            } else if (detail.detalleTipoNombre === DetalleTipo.Texto) {
                _textDetails.push({ nombre: detail.nombre!, valor: detail.valor?.toString() })
            } else if (detail.detalleTipoNombre === DetalleTipo.Mapa && !!detail.valor?.longitud) {
                setLocation({ longitud: detail.valor?.longitud, latitud: detail.valor?.latitud });
                mapRef.current?.setView({ lat: detail.valor?.latitud, lng: detail.valor?.longitud }, 10);
                setIsLocation(true);                
            }
        });
        setTelefono(_telefonos);
        setDetalle(_textDetails);
    }

    useEffect(() => {
        getFormsListDetails();
        localStorage.setItem('IsLeave', JSON.stringify(true));

    }, []);

    useEffect(() => {
        return () => {


            const isLeavePage = JSON.parse(localStorage.getItem('IsLeave') || 'null');
            if (isLeavePage) {
                desbloquearEntidad();
            }
        }

    }, [])

    useEffect(() => {
        handleAsingValueDetail();
        
    }, [listFormsListDetails])

    return (

        <div >

            <div className={"nav_header_detail"}>
                <LogoBis />
                <MenuHeader nameForm={questionForm?.nombre} currentPage={"Detalle"} isMenu={false} />
            </div>
            <div className="container-detail">
                <div className="container-detail-side1">
                    <div className="detail-side1-boxTitle" >
                        <h1>{entitySurveySelected?.nombre}</h1>
                        <h3 className="detail-side1--boxTitle-boxSub-var">{entitySurveySelected?.codigo}</h3>
                    </div>
                    <div className='container-detail-atributes'>
                        {listFormsListDetails?.length === 0
                            ? formLoading.toString() === 'true'
                                ? <LoadingPage />
                                : <LabelNotFound message="No se encontró la busqueda data." />
                            :
                            <>
                                <div>
                                    {
                                        telefono.length != 0 ? 
                                            <div className="boxAtribute1" >
                                                <h2 className="detail-side1-boxSub-label">{"Contactos"}</h2>
                                                {telefono.map((numero, index) => (<h3 key={index} className="detail-side1-boxSub-var">{numero}</h3>))}
                                            </div>
                                        : null}
                                </div>
                                <div>
                                    {
                                        isLocation ?
                                            <div className='boxAtribute1'>
                                                <h2 className="detail-side1-boxSub-label">{"Mapa"}</h2>
                                                <h3><a className='detail-side1-boxSub-var' href={googleMapsUrl} target="_blank" rel="noopener noreferrer">Abrir Link</a></h3>
                                            </div>
                                        : null
                                    }
                                </div>
                                <div>{
                                    detalle.length != 0 ? detalle.map(detal => (
                                        <div className="boxAtribute1" >
                                            <h2 className="detail-side1-boxSub-label">{detal.nombre}</h2>
                                            <h3 className="detail-side1-boxSub-var">{!!detal.valor?.trim() ? detal.valor : '---'}</h3>
                                        </div>  
                                    )) : null}
                                </div>
                            </>
                        }
                    </div>

                    <LoadingButton title={"Iniciar Encuesta"} background={COLORS.blue_active} color={COLORS.white_color1} loading={formLoading.toString()} method={() => goToSecuentialSurvey()} fontsize={20} type={'button'} />

                </div>
                <div className="container-detail-side2">
                    <MapContainer ref={mapRef} center={[19.78738018198620, -70.97991943359370]} zoom={13} scrollWheelZoom={false}>
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <>{isLocation ?
                            <Marker position={[location.latitud!, location.longitud!]}>
                                <Popup>{entitySurveySelected?.nombre}</Popup>
                            </Marker>
                            :
                            <SVGOverlay bounds={objMapa.bounds}>
                                <rect x="0" y="0" width="100%" height="100%" fill={COLORS.black_text_color3} />
                                <text x="18%" y="50%" color={COLORS.white_color2(1)} >
                                    {objMapa.text}
                                </text>
                            </SVGOverlay>
                        }
                        </>


                    </MapContainer>
                </div>

            </div>

        </div>
    )
}

export default DetalleEntidadEncuestada;